import { AxiosError } from 'axios';
import { MessageDescriptor } from 'gatsby-plugin-intl';
import { pathEq } from 'ramda';
import pathSatisfies from 'ramda/es/pathSatisfies';
import startsWith from 'ramda/es/startsWith';

const NETWORK_ERROR = 'Network Error';

export const isNetworkError = pathSatisfies<string, AxiosError>(startsWith(NETWORK_ERROR), ['message']);

export const errorCodeIs = (error: string): ((error: AxiosError) => boolean) =>
  pathEq(['response', 'data', 'code'], error);

export const errorIsAnyCode = (error: AxiosError, ...codes: (string | string[])[]): error is AxiosError<{ code: string }> =>
  Boolean(codes.flat().find(code => errorCodeIs(code)(error)));

export const isAxiosError = (error: unknown): error is AxiosError => Boolean((error as any)?.isAxiosError);

export const getErrorMessage = (errorCodes: Record<string, MessageDescriptor>, error: unknown): MessageDescriptor => {
  if (isAxiosError(error)) {
    const foundError = Object.entries(errorCodes).find(([code]) => {
      return pathEq(['response', 'data', 'code'], code);
    });

    if (foundError) {
      return foundError[1];
    }

    if (isNetworkError(error)) {
      return { id: 'error.request.NET_ERR' };
    }
  }


  return errorCodes.default ?? { id: 'error.request.UNKNOWN' };
};
